<template>
    <div class="msg">
        <div class="item" v-for="( param, key ) in params" v-if="typeof param.visible === 'undefined' || param.visible" :class="[param.type, param.style]" :key="key">
            <Phone class="value" v-if="param.type == 'phone'" :phone="param.value"></Phone>
            <Email class="value" v-else-if="param.type == 'email'" :email="param.value"></Email>
            <div :id="param.id" class="param value" v-else v-html="formatParam( param )">{{ formatParam( param ) }}</div>
            <!-- <div class="value" v-else>{{ formatParam( param ) }}</div> -->
        </div>
    </div>
</template>

<script>
    import Phone from '@/components/ui/labels/Phone'
    import Email from '@/components/ui/labels/Email'

    export default {
        props: { params: Array, actions: Array, avatar: String },
        components: { Phone, Email },
        data() {
            return {
            }
        },
        methods: {
            formatParam( param ){
                switch( param.type ){
                    case 'string': return param.value;
                    case 'role': return param.value.name;
                    case 'email': return param.value;
                    case 'date': return moment(param.value).format('YYYY-MM-DD  HH:mm');
                    case 'phone': return "<v-icon size='18px'>phone</v-icon>" + param.value;
                    case 'textarea': if( param.style == 'disabled' ) return param.value;
                                     else return "<textarea id='note_edit' style='width:100%; min-height:200px;padding:15px;'>" + param.value + "</textarea>";
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .avatar {
        width: 100%;
        height: 150px;
        text-align: center;

        img {
            height: 100%;
            width: auto;
        }
    }

    .item {
        text-align: left;
        margin: 5px 0;
        width: fit-content;


        .value {
            font-size: 14px;
            color: #666;
        }
        &.strong .value {
            font-weight: bold;
            color: #111;
            font-size: 16px;
        }

        &.textarea {
            /*min-height: 200px;*/
            width: 100%;
            /* text-overflow: ellipsis; */
            word-wrap: break-word;
            margin-bottom: 25px;
            color: #111;

            .value {
                font-size: 16px;
                
            }

            &.disabled {
                border-left: 3px solid #ccc;
                border-radius: 0;
                padding: 10px;
            }

            .value {
                /*min-height: 200px;*/
                width: 100%;

                textarea {
                    width: 100% !important;
                    min-height: 200px;
                    padding: 15px !important;
                }
            }
        }
    }
</style>